import React from "react";
import Header from "../Common/Header";
import Footer from "../Common/Footer";
import Sidebar from "../Common/Sidebar";

import { Outlet } from "react-router-dom";
const Layout = () => {
  return (
    <>
    <div id="yoc_scrolltop" class="yoc-scrolltop">
        <i class="fa fa-arrow-up"></i>
    </div>
      <div className="yoc-grid yoc-grid--hor yoc-grid--root">
        <div className="yoc-grid__item yoc-grid__item--fluid yoc-grid yoc-grid--ver yoc-page">
          <button className="yoc-aside-close" id="yoc_aside_close_btn">
            <i className="la la-close"></i>
          </button>
          <Sidebar />

          <div
            className="yoc-grid__item yoc-grid__item--fluid yoc-grid yoc-grid--hor yoc-wrapper"
            id="yoc_wrapper"
          >
          <Header  />

          <div
          className="yoc-content yoc-grid__item yoc-grid__item--fluid yoc-grid yoc-grid--hor"
          id="yoc_content">
            
            <div className="yoc-container yoc-container--fluid yoc-grid__item yoc-grid__item--fluid">
              <Outlet />
            </div>

            <Footer />
          </div>
        </div>
      </div>
      </div>
    </>
  );
};
export default Layout;
